import { useTablePagination } from '@/common/hooks/useTablePaginate'
import { Button } from '../button'

export function DataTableResetFilter() {
	const { isAnyFilterActive, resetFilters } = useTablePagination()
	return (
		<>
			{isAnyFilterActive ? (
				<Button
					variant="outline"
					onClick={resetFilters}
					size="sm"
					className="h-8 px-3 text-xs sm:h-9 sm:px-4 sm:text-sm"
				>
					ล้าง
				</Button>
			) : null}
		</>
	)
}
